import { styled, FormControlLabel } from '@mui/material';

export const StyledCheckbox = styled(FormControlLabel)`
  & .MuiFormControlLabel-label {
    display: flex;
  }
`;
